import React, { useEffect, useState } from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  ArcElement,
  LineElement,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import * as Charts from "react-chartjs-2";

export enum ChartType {
  LINE = "line",
  BAR = "bar",
  CIRCLE = "circle",
}
interface Props {
  id?: string;
  data: any;
  graphOptions: any;
  chartType: string;
}

const defaultOptions = {
  scales: {
    y: {
      beginAtZero: true,
      grid: {
        display: false,
      },
    },
  },
};

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  LineElement,
  BarElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);

export const Chart: React.FC<Props> = (props) => {
  const { id, data, graphOptions, chartType } = props;

  const [options, setOptions] = useState(defaultOptions);

  const renderChart = () => {
    switch (chartType) {
      case ChartType.LINE:
        return (
          <Charts.Line
            id={id}
            data={{
              ...data,
              datasets: [
                {
                  ...data.datasets[0],
                  clip: false,
                },
              ],
            }}
            options={options}
          />
        );
      case ChartType.BAR:
        return <Charts.Bar id={id} data={data} options={options} />;
      default:
    }
  };

  const handleSetOptions = () => {
    const option = {
      ...defaultOptions,
      ...graphOptions,
    };

    setOptions((state) => (state ? { ...state, ...option } : { ...option }));
  };

  useEffect(() => {
    if (graphOptions) {
      handleSetOptions();
    }
  }, [graphOptions]);

  return (
    <section className="h-100">
      <div className="position-relative h-100">{renderChart()}</div>
    </section>
  );
};
